/*
 * Copyright (c) Nexign, JSC, 2022.
 */
/**
 * Lazy loading of the component PageReportsSubscribers
 *
 * @author Ilya Babanov
 * @version 1.22.0
 * @since 1.22.0
 */
import loadable from '@utils/loadable';

export default loadable(
	() =>
		import(/* webpackChunkName: "PageReportsSubscribers" */ './PageReportsSubscriber').then((module) => ({
			default: module.PageReportsSubscriber,
		})),
	undefined,
);
